// extracted by mini-css-extract-plugin
export default {"esport":"fiv_eEI2We4m3yMfNH6S","events":"g7P5yR0sfw2yTOswcg2c","articles":"yd8GWAnrwU0M0qwoOKvy"};